import { formatPlanPrice } from '@/libs/utils/format-plan-price';
import { Text } from '@chakra-ui/react';
import type { SubscriptionPriceDropOffer } from '@fluenceur/types';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { formatSettingsDate } from '../format-settings-date';

interface PriceDropSummaryProps {
  offer: SubscriptionPriceDropOffer;
}

/**
 * The sentence naming both prices and when the lower one starts being billed.
 *
 * Amounts go through the same formatter as the plan price above it, so the two
 * figures read identically. Without a date the sentence points at the next
 * billing date rather than inventing one.
 */
export const PriceDropSummary: React.FC<PriceDropSummaryProps> = ({ offer }) => {
  const { t } = useTranslation();
  const locale = t('common.locale');

  const prices = {
    current: formatPlanPrice(offer.currentAmount, offer.currency, locale),
    new: formatPlanPrice(offer.newAmount, offer.currency, locale),
  };

  const sentence = offer.effectiveAt
    ? t('settings.subscription.priceDrop.body', {
        ...prices,
        date: formatSettingsDate(offer.effectiveAt, locale),
      })
    : t('settings.subscription.priceDrop.bodyWithoutDate', prices);

  return <Text fontSize="sm">{sentence}</Text>;
};
